/**
 * GET Approvers Action
 */
import * as _ from 'lodash-es';

import {
  ACTION_GET_APPROVERS,
  ACTION_GET_APPROVERS_SUCCESS,
  ACTION_GET_APPROVERS_FAILURE,
  ACTION_EMPTY_APPROVERS,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

/**
 * POST Users Request Action
 */
export function getApprovers(userId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `user/${userId}/approvers/`,
        method: 'get',
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_APPROVERS,
    payload: null,
  };
}

export function requestSuccess(responeJSON: object) {
  return {
    type: ACTION_GET_APPROVERS_SUCCESS,
    payload: responeJSON,
  };
}

export function requestFailed(responeJSON: object) {
  return {
    type: ACTION_GET_APPROVERS_FAILURE,
    payload: responeJSON,
  };
}

export function emptyAapprovers() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_EMPTY_APPROVERS,
      payload: null,
    });
  };
}
